export default __webpack_public_path__ + "static/media/MyPortfolio.ead68fdf.jpg";